<template>
  <div class="row mb-3">
    <div class="d-flex flex-row col-12">
      <div class="col col-md-3 pl-4 pr-0">
        <b-button pill class="text-center button-danger " size="lg" variant="outline-danger"
          style=" border: none;width: 169px; " @click="$emit('limpiar')" :disabled="disabledBtnLimpiar">
          Quitar todos los filtros
        </b-button>

      </div>
      <div class="col col-md-3 p-0">
        <button @click="$emit('historial')" type="button" :v-show="showHistorial" class="
            button-primary button-primary-lf
            mt-4
            redondo-8
            border-none
            sm
            p-2
          ">
          <span class="cta-small m-6">
            Historial de edición
            <span class="icon icon-clock ml-2 mb-0"></span>
          </span>
        </button>
      </div>
      <div class="col col-md-6 p-0">
        <button class="button-secundary rounded-pill mt-4 " v-b-toggle.accordion-1 variant="light" style="margin-left: auto;
margin-bottom: 10px;
margin-right: 0px;
position: realtive;
width: 121px;
height: 40px;
border-radius: 100px;">
          <span class="ml-2">
            Filtros
            <img class="centerImg1 pl-0 ml-2 mr-2 mt-1" src="@/assets/images/icons/filter.svg" />
          </span>
        </button>

      </div>
    </div>
    <div class="col-12">
      <b-collapse id="accordion-1" class="filtros ml-4" accordion="my-accordion" role="tabpanel" align="left">
        <b-overlay :show="loading">
          <b-card-body class="card mb-3 py-0 pb-4">
            <div class="row">
              <slot></slot>
            </div>
          </b-card-body>
          <template #overlay>
            <overlay-button></overlay-button>
          </template>
        </b-overlay>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import OverlayButton from "@/components/core/overlay/overlay-button.vue";
export default {
  name: "filter-content",
  components: { OverlayButton },
  props: {
    imgClass: {
      type: String,
      default: "col-4",
    },
    showHistorial: {
      type: Boolean,
      default: false,
    },
    disabledBtnLimpiar: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["limpiar", "historial"],
};
</script>

<style>
.card-header {
  background-color: none !important;
}
.card {
  background: #ffffff !important;
  box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.14) !important;
  border-radius: 12px !important;
}
</style>